import confetti from 'canvas-confetti';

export const sideCanon = (duration = 5000) => {
  const end = Date.now() + duration;

  const params = {
    zIndex: 202,
    particleCount: 2,
    spread: 10,
  };
  const paramsLeft = {
    ...params,
    angle: -60,
    origin: { x: 0, y: 0 },
  };
  const paramsRight = {
    ...params,
    angle: -120,
    origin: { x: 1, y: 0 },
  };

  (function frame() {
    confetti({
      ...paramsLeft,
      angle: paramsLeft.angle + 10,
      colors: ['#002653'],
    });
    confetti({
      ...paramsLeft,
      particleCount: 4,
      spread: 30,
      colors: ['#ffffff'],
    });
    confetti({
      ...paramsLeft,
      angle: paramsLeft.angle - 10,
      colors: ['#ce1127'],
    });
    confetti({
      ...paramsRight,
      angle: paramsRight.angle + 10,
      colors: ['#002653'],
    });
    confetti({
      ...paramsRight,
      particleCount: 4,
      spread: 30,
      colors: ['#ffffff'],
    });
    confetti({
      ...paramsRight,
      angle: paramsRight.angle - 10,
      colors: ['#ce1127'],
    });

    if (Date.now() < end) {
      requestAnimationFrame(frame);
    }
  })();
};
